export default __webpack_public_path__ + "static/media/pruvodce_sebepoznanim.c5ed7a49.jpg";